import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { IEventItem } from '../../../../store/player/events/store';

import { navigateTo } from '../../../../contrib/Utils/navigateTo';
import { getEventField } from '../../../../contrib/Utils/getEventField';
import { useEventEntriesAvailable } from '../../../../contrib/Hooks/useEventEntriesAvailable.hook';
import { EventContentStyled } from './EventContent.Styles';
import { defaultClubLogo, placeholderImage } from '../../../../assets/images';
import { getEnrollmentsIdsInEventTeesheet } from '../../../Utils/getEnrollmentsIdsInEventTeesheet';

interface IProps {
  item: IEventItem;
}

const EventContent = (props: IProps) => {
  const {
    item,
    item: {
      id: itemId,
      name: eventName,
      start,
      image: eventImage,
      enrollment: { status, id },
      club,
      club: { profileImage: clubProfileImage, name: clubName }
    }
  } = props;

  const [entriesAvailable] = useEventEntriesAvailable(item);

  const enrollmentsIdsInEventTeesheet = getEnrollmentsIdsInEventTeesheet(item);

  const eventStatusMetadata =
    status === 'active' || enrollmentsIdsInEventTeesheet.includes(id)
      ? 'IN'
      : status in ['invited', 'waiting']
      ? 'TBD'
      : status in ['canceled', 'bounced', 'canceled-waiting']
      ? 'OUT'
      : 'TBD';

  const [itemFieldName, setItemFieldName] = useState('');

  useEffect(() => {
    if (item) {
      setItemFieldName(getEventField(item).name);
    }
  }, [item]);

  return (
    <EventContentStyled
      className="event-content"
      style={{ backgroundImage: `url(${eventImage ? eventImage : placeholderImage})` }}
      onClick={navigateTo(`/event/${itemId}`)}
    >
      <div className="bg-wrapper">
        <div className="bg-mask2" />
      </div>

      <div className="event-metadata">
        <div className="logo-container">
          {typeof club !== 'number' && club && clubProfileImage ? (
            <img src={clubProfileImage} alt={`${clubName} logo`} />
          ) : (
            <img src={defaultClubLogo} alt={`${eventName} logo`} />
          )}
        </div>

        <div className={`event-player-status ${eventStatusMetadata.toLowerCase()}`}>
          <span>{eventStatusMetadata}</span>
        </div>

        <p className="event-date">{moment(start).format('LL')}</p>

        <p className="title">{eventName}</p>

        <p className="location">{itemFieldName}</p>

        <p className="info">{`${entriesAvailable} ENTRIES AVAILABLE`}</p>
      </div>
    </EventContentStyled>
  );
};

export default EventContent;
